export const GOOGLE_GEOCODE_API =
  'https://maps.googleapis.com/maps/api/geocode/json'
export const GOOGLE_MAP_SEARCH_LINK =
  'https://www.google.com/maps/search/?api=1&query='
